import React from 'react';
import { Check, Minus } from 'lucide-react';
import { beforeAfterRows } from '../data/offer';
export function BeforeAfter() {
  return <section className="py-24 px-4 bg-sand-light" data-id="element-19" data-mp="69msi75fsq2t">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="3og1bikikbq82">
        <h2 className="text-3xl md:text-5xl font-display font-extrabold text-navy text-center mb-12" data-id="element-21" data-mp="3of83zhbs4wov">
          Before vs. After Mountain Bike Coach Ready
        </h2>

        <div className="rounded-2xl overflow-hidden border border-line bg-white shadow-sm" data-id="element-22" data-mp="3epojk78f4urw">
          <div className="grid grid-cols-2 text-sm font-bold" data-id="element-23" data-mp="3jh6o159nhdhm">
            <p className="px-5 py-4 bg-sand text-muted" data-id="element-24" data-mp="3jihq90ng6d6m">BEFORE</p>
            <p className="px-5 py-4 bg-forest text-white" data-id="element-25" data-mp="34t3hnurp3zsa">AFTER</p>
          </div>
          {beforeAfterRows.map((row, index) => <div key={row.before} className="grid grid-cols-2 border-t border-line" data-id="element-26" data-mp="39oiq276xp3hb" data-mpi={index}>
              <p className={`px-5 py-4 flex items-start gap-2.5 text-muted ${index === 0 ? 'text-lg italic' : 'text-base'}`} data-id="element-27" data-mp="2vt6ww48ffl2i">
                <Minus size={16} className="text-muted/60 shrink-0 mt-1" aria-hidden="true" data-id="element-28" data-mp="x3sfybomr4r3" />
                {row.before}
              </p>
              <p className={`px-5 py-4 flex items-start gap-2.5 bg-seafoam-light/60 text-forest font-semibold ${index === 0 ? 'text-lg italic' : 'text-base'}`} data-id="element-29" data-mp="t51ig3g95l3g">
                <Check size={16} strokeWidth={3} className="text-seafoam-dark shrink-0 mt-1" aria-hidden="true" data-id="element-30" data-mp="124g66v51bhk9" />
                {row.after}
              </p>
            </div>)}
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3 text-center font-display font-black text-xl md:text-2xl" data-id="element-31" data-mp="9gsq9teplf3y">
          <p className="py-4 text-navy" data-id="element-32" data-mp="jd5livpwk10t">LESS GUESSING.</p>
          <p className="py-4 text-navy" data-id="element-33" data-mp="jbkq73vrke1w">LESS PLANNING.</p>
          <p className="py-4 text-navy" data-id="element-34" data-mp="3rsfg7irgq3yk">LESS IMPROVISING.</p>
          <p className="py-4 text-orange" data-id="element-35" data-mp="3rqvydnq5rkuo">MORE COACHING.</p>
        </div>
      </div>
    </section>;
}